import React from "react";
import { Link } from "react-router-dom";
import "./SignUpButton.css";

function SignUpButton() {
  return (
    <Link to="signup">
      <button className='btn-signup'>Sign Up</button>
      {/* <button className='btn signup'>Sign Up</button> ? */}
    </Link>
  );
}

export default SignUpButton;